module.exports = __webpack_public_path__ + "img/veri3.70ec3485.jpg";